module.exports = __webpack_public_path__ + "static/media/bug.00ec4b5b.png";